module.exports = __webpack_public_path__ + "img/user_avatar.5de51f41.jpeg";